<template>

<router-link :to="{name: url}" class="button" :class="{[classIcon]: true}"><span>{{ text }}</span></router-link>

</template>

<script>

export default {

	props: ['text', 'icon', 'url'],

	computed: {

		classIcon: function() {

			return 'icon-' + this.icon

		}

	}

}

</script>

<style scoped>

.button {
	margin-bottom: 16px;
	border: 3px solid #f6f6f6;
	border-radius: 32px;
	display: block;
	padding: 0px 0px 0px 64px;
	height: 64px;
	line-height: 60px;
	width: 320px;
	transition: all 300ms ease-in-out;
}

.is-mobile .button {
	width: 100%;
}

.button:hover {
	background-color: #343434;
	border-color: #343434;
}

.button span {
	color: #343434;
	font-size: 12px;
	font-weight: bold;
	letter-spacing: 1px;
	text-transform: uppercase;
	transition: all 300ms ease-in-out;
}

.button:hover span {
	color: #fff;
}

.button:before {
	content: ' ';
	width: 44px;
	height: 44px;
	left: 7px;
	top: 7px;
	border-radius: 50%;
	position: absolute;
	background-color: #343434;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.button.icon-create:before {
	background-image: url(~@/assets/home.create.svg);
}

.button.icon-open:before {
	background-image: url(~@/assets/home.open.svg);
}

</style>
